import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getExpenseCategoryApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getExpenseCategoryList = createAsyncThunk('getExpenseCategoryList', async (payload) => {
  return await getExpenseCategoryApi(payload);
});

const getExpenseCategoryListSlice = createSlice({
  name: 'getExpenseCategoryList', // Unique Name
  initialState,
  reducers: {
    getExpenseCategoryListReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getExpenseCategoryList.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getExpenseCategoryList.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getExpenseCategoryList.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getExpenseCategoryListReset } = getExpenseCategoryListSlice.actions;

export default getExpenseCategoryListSlice.reducer;
